export namespace IDiscoverPageLayoutRequest {
  /**
   * Return an instance of IDiscoverPageLayoutRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IDiscoverPageLayoutRequest>
  ): IDiscoverPageLayoutRequest =>
    ({
      filter_keys: [],
      ...(partial ?? {}),
    }) as IDiscoverPageLayoutRequest;
}

export interface IDiscoverPageLayoutRequest {
  featured_product_token: string | undefined;
  query: string | undefined;
  filter_keys: Array<string>;
  /**
   * Limits the number of LayoutElement.layoutElementData to return.
   */
  layout_elements_data_limit: number | undefined;
}
